module.exports = __webpack_public_path__ + "static/media/verdeSam.3f644768.jpg";